import type { FC } from "react";
import { Loader } from "./Loader";

interface SpinnerProps {
	size?: number;
}

export const Spinner: FC<SpinnerProps> = (props) => {
	const { size = 48 } = props;
	const preset = size <= 20 ? "sm" : size >= 64 ? "lg" : size;
	return <Loader size={preset} />;
};
